import { Controller } from "@hotwired/stimulus";
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ["switch"]
  static values = {
    enableUrl: String,
    disableUrl: String,
  }

  toggle() {
    if (this.switchTarget.checked) {
      this.enable()
    } else {
      this.disable()
    }
  }

  enable() {
    this.patch(this.enableUrlValue)
  }

  disable() {
    this.patch(this.disableUrlValue)
  }

  patch(endpoint) {
    fetch(endpoint, {
      method: 'PATCH',
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": Rails.csrfToken(),
      },
    })
  }
}
